import { Box, Button, Heading, TextButton } from '@wix/design-system'
import { ChoiceQuestionContentComponent, useContent, useNext } from '@wix/funnel-builder-lizard'
import classNames from 'classnames'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { DesignSystemTokensLoader } from '../../reusable/DesignSystemTokensLoader'
import s from './SorryNew.scss'

export type Content = {
  title: string
  subtitle: string
  question: ChoiceQuestionContentComponent<{}, { label: string }>
}

export const SorryNew: FC = () => {
  const { content } = useContent<Content>()
  const { questionKey } = content.question
  const next = useNext()

  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleClick = (optionKey: string) => {
    void pageLogger.answer({ answer: optionKey })
    next({
      [questionKey]: {
        values: [optionKey],
      },
    })
  }

  return (
    <DesignSystemTokensLoader type="odeditor">
      <Box className={s.SorryNew}>
        <div className={s.SorryNew__content}>
          <Heading className={s.SorryNew__title}>{content.title}</Heading>
          <span className={s.SorryNew__subtitle}>{content.subtitle}</span>
          <Box className={s.SorryNew__navigation} direction="vertical" gap="18px">
            <Button
              className={s.SorryNew__btn}
              size="large"
              onClick={() => handleClick(content.question.options[0].optionKey)}
              skin="dark"
            >
              {content.question.options[0].label}
            </Button>
            <TextButton
              className={classNames(s.SorryNew__btn, s.SorryNew__btnSecondary)}
              underline="always"
              skin="dark"
              onClick={() => handleClick(content.question.options[1].optionKey)}
            >
              {content.question.options[1].label}
            </TextButton>
          </Box>
        </div>
      </Box>
    </DesignSystemTokensLoader>
  )
}
